import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BaseComponent } from '../component-base';
import { Component, OnInit, Renderer2, Inject, Input, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AjaxInterceptorService } from '../../interceptors/AjaxInterceptorService';
import { CacheService } from '../../services/cashe-service';
import { APP_ROUTER } from '../../models/app.route';
import { AuthService } from '../../services/authentication/auth.service';
import { ProcessService } from 'src/app/modules/workFlow/services/process.service';
import { SignalRService } from '../../services/signalr/SignalRService';
import { LookupBase } from '../../models/lookup.base.model';
import { ApiResponse } from '../../models/api-response.model';
import { CompanyService } from '../../../modules/services/license/company/services/company.service';
import { Company } from '../../../modules/services/license/company/models/Company';
import { NotificationsServicesService } from 'src/app/modules/services/license/notification-log/services/notifications-services.service';
import { notificationDto } from 'src/app/modules/services/license/notification-log/models/notificationDto';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseComponent implements AfterViewInit {

  @Input() isAdmin: boolean = false;
  fullName: string;
  employeeImg:string;
  isAuthenticated: boolean = false;
  isCompleteCompany: boolean = false;
  agencyName: string;
  inboxCount: number;
  MyCompanies: LookupBase[];
  currentCrNumber: any;
  currentRelationType:any;
  isCompanyLogin:any;
  constructor(
    public _companyprofileService: CompanyService,
    private signalRService: SignalRService,
    private processService: ProcessService,
    private ajaxInterceptorSvc: AjaxInterceptorService,
    private _authService: AuthService,
    public router?: Router,
    public translate?: TranslateService,
    public _notificationsServicesService?: NotificationsServicesService,
    public renderer?: Renderer2
  ) {
     super();
    // setTimeout(() => {
    //   this.loadScript('assets/myUI/app-assets/vendors/js/vendors.min.js');
    // this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
    // this.loadScript('assets/myUI/app-assets/js/core/app.js');
    // }, 500); // Delay to ensure DOM is ready
  }


  isActive(path: string): boolean {
    return this.router.url === path || this.router.url.startsWith(path);
  }
  scripts = [
    'assets/myUI/js/jquery.js',
    'assets/myUI/app-assets/vendors/js/vendors.min.js',
    'assets/myUI/app-assets/js/core/app-menu.js',
    'assets/myUI/app-assets/vendors/js/charts/raphael-min.js',
    'assets/myUI/app-assets/js/core/app.js'
  ];
  
    // Load scripts in order
    loadAllScripts() {
      try {
        this.loadScript2(this.scripts[0])
        .then(() => this.loadScript2(this.scripts[1]))
        .then(() => this.loadScript2(this.scripts[2]))
        .then(() => this.loadScript2(this.scripts[3]))
        .then(() => this.loadScript2(this.scripts[4]))
        .then(() => console.log('All scripts loaded successfully'))
        .catch(error => console.error('Script loading error:', error));
  
  
  
        // this.loadScript('assets/myUI/js/jquery.js');
        // setTimeout(() => {
        //   this.loadScript('assets/myUI/app-assets/vendors/js/vendors.min.js');
        // }, 100); // Delay to ensure DOM is ready
        // setTimeout(() => {
        //   this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
        //   // this.loadScript('assets/myUI/app-assets/js/core/app.js');
  
        // }, 300); // Delay to ensure DOM is ready
        // setTimeout(() => {
        //   //this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
        //   this.loadScript('assets/myUI/app-assets/js/core/app.js');
        // }, 700); // Delay to ensure DOM is ready
    
        window.onload = () => {
          console.log('✅ All scripts and assets have loaded.');
        };
      } catch (error) {
        console.error('❌ Error loading scripts:', error);
      }
  
  
    }
    ngAfterViewInit() {
    
      //this.loadAllScripts();
      }

      private loadCSS(href: string): void {
        const link = this.renderer.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        this.renderer.appendChild(document.head, link);
      }
  private loadJS(src: string): void {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.defer = true;
    this.renderer.appendChild(document.body, script);
  }
  // loadScript(src: string): void {
  //   const script = this.renderer.createElement('script');
  //   script.src = src;
  //   script.type = 'text/javascript';
  //   script.defer = true;
  //   this.renderer.appendChild(document.body, script);
  // }

  loadScript2(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // if (!window['$']) {
      //   console.error('❌ jQuery is not loaded yet.');
      //   reject();
      //   return;
      // }

      const script = this.renderer.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      script.defer = true;

      script.onload = () => {
        console.log(`✅ Loaded: ${src}`);
        resolve();
      };

      script.onerror = () => {
        console.error(`❌ Failed to load: ${src}`);
        reject();
      };

      this.renderer.appendChild(document.body, script);
    });
  }

  // GetNewNotificationLogsCount() {
  //   this._notificationsServicesService
  //     .GetNewNotificationLogsCount()
  //     .subscribe((data) => {
  //       debugger;
  //       this.notificationsCount =  data.value;
  //     });
  // }
mynotifications :notificationDto[];

  GetNewNotificationLogsCount() {
    this._notificationsServicesService
      .GetNewNotificationLogs()
      .subscribe((data) => {
        this.mynotifications = data.value;
        this.notificationsCount =  this.mynotifications.length;
      });
  }



  ngOnInit() {

     //this.loadAllScripts();
    // setTimeout(() => {
      // this.loadScript('assets/myUI/app-assets/vendors/js/vendors.min.js');
    // this.loadScript('assets/myUI/app-assets/js/core/app-menu.js');
    // this.loadScript('assets/myUI/app-assets/js/core/app.js');
    // }, 500); // Delay to ensure DOM is ready
    var rrr = CacheService.getRole();
    // this.isCompanyLogin= JSON.parse( localStorage.getItem("isCompanyLogin"));
    this._authService.isUserLogin$.subscribe((val: boolean) => {
      this.isAuthenticated = val;
      this.fullName = CacheService.getFullName();
      
      this.agencyName = CacheService.getAgencyName();

    });

    
    if (CacheService.getToken()) {
      this.fullName = CacheService.getFullName();
      this.agencyName = CacheService.getAgancy();
      this.currentCrNumber= CacheService.getCurrentCompany();
      this.currentRelationType= CacheService.getRelationType();
      this.employeeImg = CacheService.getEmployeeImg();

      this.isAuthenticated = true;
    } else {
      this.isAuthenticated = false;
    }
    if (this.isAuthenticated) {
      // this.getInboxCount();
    }

    const currentUrl = this.router.url;
    // this.GetCompany(this.currentCrNumber);
    // if (currentUrl.includes('complete-company')) {
    //   this.isCompleteCompany = false;
    //   this.isAuthenticated = false;
    // } else {
    //   this.isCompleteCompany = true;
    //   this.isAuthenticated = true;
    // }

    // this.isAuthenticated = Boolean(CacheService.getShowHeader());

    //this.loadAllScripts();
  // this.GetNewNotificationLogsCount();
  }
notificationsCount:number;
  public Company: Company;

  GetCompany(crn){
    var comp = CacheService.getMyCurrenCompanyData();
    if(comp ==null || comp==undefined){
      this.GetCompanyProfileRequestById(crn);
    }else{
      this.Company = comp as Company;
    }
    }
  GetCompanyProfileRequestById(cr): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this._companyprofileService.getCompanyProfileRequestByCRN(cr).subscribe((data: ApiResponse<Company>) => {
        this.Company = data.value;
        CacheService.setMyCurrenCompanyData(this.Company);
        // this.CheckIfCompanyIsExpired();
        resolve();

      });
    });
  }
  AllowToAddRequest: boolean = true;

  getInboxCount() {
    this.processService
      .getNotificationCount()
      .subscribe((data) => {
        this.inboxCount = data.value
      });
  }

  logout() {
    CacheService.clearCache();
    this._authService.isUserLogin$.next(false);
    this.router.navigate([APP_ROUTER.LOGIN]);
  }

  changeLanguage(lang) {
    localStorage.setItem('lang', lang);
    location.href = location.href;
  }

  changePassword() {
    this.router.navigate(['/changepassword']);
  }
}
